import { Link } from "react-router-dom";

export default function CtaBanner() {
  return (
    <section className="w-full px-4 md:px-8 pb-4" aria-labelledby="home-cta-title">
      <div className="max-w-7xl mx-auto relative overflow-hidden rounded-lg bg-foreground-950">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20amber%20stage%20spotlights%20and%20soft%20haze%20with%20deep%20shadowed%20silhouettes%20of%20empty%20seats%2C%20cinematic%20abstract%20minimal%20composition%2C%20analog%20film%20grain%2C%20moody%20editorial%20atmosphere&width=1600&height=600&seq=chigua-cta-01&orientation=landscape"
          alt="暖色舞台灯光与薄雾氛围背景"
          title="吃瓜片场 私拍吃瓜合集"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/90 via-foreground-950/75 to-foreground-950/60" />
        <div className="relative px-6 md:px-12 py-14 md:py-20 flex flex-col lg:flex-row lg:items-center gap-8 lg:gap-12">
          <div className="lg:flex-1">
            <h2
              id="home-cta-title"
              className="font-heading text-2xl md:text-4xl font-bold text-background-50 leading-snug max-w-xl"
            >
              找到你想看的那一类，从分类开始更省时间
            </h2>
            <p className="text-sm md:text-base text-background-100/85 leading-relaxed mt-4 max-w-xl">
              五个分类、上百条片段已经排好顺序。若你有现场线索或想补充的细节，也欢迎直接告诉我们。
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 lg:shrink-0">
            <Link
              to="/collections"
              className="px-7 py-3.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors text-center whitespace-nowrap"
            >
              进入合集大厅
            </Link>
            <Link
              to="/contact"
              className="px-7 py-3.5 rounded-md border border-background-50/40 text-background-50 text-sm font-medium hover:bg-background-50/10 transition-colors text-center whitespace-nowrap"
            >
              提交线索
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}